var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "web-tabs-list-page" },
    [
      _c("AppBreadCrumb", {
        attrs: { paths: [{ title: _vm.$t("webTabsPage.breadcrumbTitle") }] },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-header p-2" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.$t("webTabsPage.listPageTitle")))]),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$router.push("/integrations/webtabs/new")
                },
              },
            },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("webTabsPage.buttonNew")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-card",
        { staticClass: "p-2", attrs: { loading: _vm.loading } },
        [
          _c("a-table", {
            attrs: {
              columns: _vm.columns,
              "data-source": _vm.webTabs,
              "row-key": function (record) {
                return record._id
              },
              pagination: { pageSize: 10 },
            },
            scopedSlots: _vm._u([
              {
                key: "icon",
                fn: function (text, record) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "material-icons",
                        style: { color: record.iconColor || "#6b727d" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(record.icon) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "name",
                fn: function (text, record) {
                  return [
                    _c("div", [
                      _c("div", { staticStyle: { "font-weight": "500" } }, [
                        _vm._v(_vm._s(record.name)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "font-size": "12px", color: "#999" } },
                        [_vm._v(_vm._s(record.description))]
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "type",
                fn: function (text) {
                  return [
                    text === "url"
                      ? _c("a-tag", { attrs: { color: "blue" } }, [
                          _vm._v("URL"),
                        ])
                      : text === "app"
                      ? _c("a-tag", { attrs: { color: "purple" } }, [
                          _vm._v("App"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "placement",
                fn: function (text) {
                  return [
                    text === "menu"
                      ? _c("a-tag", { attrs: { color: "green" } }, [
                          _c(
                            "span",
                            { staticClass: "material-icons tag-icon" },
                            [_vm._v("menu")]
                          ),
                          _vm._v(
                            "\n                    Ana Menü\n                "
                          ),
                        ])
                      : text === "toolbar"
                      ? _c("a-tag", { attrs: { color: "blue" } }, [
                          _c(
                            "span",
                            { staticClass: "material-icons tag-icon" },
                            [_vm._v("web_asset")]
                          ),
                          _vm._v(
                            "\n                    Toolbar\n                "
                          ),
                        ])
                      : text === "contact-widget"
                      ? _c("a-tag", { attrs: { color: "orange" } }, [
                          _c(
                            "span",
                            { staticClass: "material-icons tag-icon" },
                            [_vm._v("contact_page")]
                          ),
                          _vm._v(
                            "\n                    Chat Widget\n                "
                          ),
                        ])
                      : text === "visitor-detail"
                      ? _c("a-tag", { attrs: { color: "purple" } }, [
                          _c(
                            "span",
                            { staticClass: "material-icons tag-icon" },
                            [_vm._v("person_search")]
                          ),
                          _vm._v(
                            "\n                    Kişi Detay\n                "
                          ),
                        ])
                      : text === "app-switcher"
                      ? _c("a-tag", { attrs: { color: "pink" } }, [
                          _c(
                            "span",
                            { staticClass: "material-icons tag-icon" },
                            [_vm._v("apps")]
                          ),
                          _vm._v(
                            "\n                    App Switcher\n                "
                          ),
                        ])
                      : text === "table-record-tab"
                      ? _c("a-tag", { attrs: { color: "cyan" } }, [
                          _c(
                            "span",
                            { staticClass: "material-icons tag-icon" },
                            [_vm._v("table_view")]
                          ),
                          _vm._v(
                            "\n                    Tablo Kayıt Sekmesi\n                "
                          ),
                        ])
                      : text === "task-detail-tab"
                      ? _c("a-tag", { attrs: { color: "volcano" } }, [
                          _c(
                            "span",
                            { staticClass: "material-icons tag-icon" },
                            [_vm._v("task_alt")]
                          ),
                          _vm._v(
                            "\n                    Görev Detay Sekmesi\n                "
                          ),
                        ])
                      : _c("a-tag", { attrs: { color: "green" } }, [
                          _c(
                            "span",
                            { staticClass: "material-icons tag-icon" },
                            [_vm._v("menu")]
                          ),
                          _vm._v(
                            "\n                    Ana Menü\n                "
                          ),
                        ]),
                  ]
                },
              },
              {
                key: "visibility",
                fn: function (text, record) {
                  return [
                    !record.visibility ||
                    ((!record.visibility.users ||
                      record.visibility.users.length === 0) &&
                      (!record.visibility.departments ||
                        record.visibility.departments.length === 0))
                      ? _c(
                          "div",
                          [
                            _c("a-tag", { attrs: { color: "green" } }, [
                              _vm._v("Herkese Açık"),
                            ]),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            record.visibility.users &&
                            record.visibility.users.length > 0
                              ? _c("a-tag", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(record.visibility.users.length) +
                                      " Kullanıcı\n                    "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            record.visibility.departments &&
                            record.visibility.departments.length > 0
                              ? _c("a-tag", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        record.visibility.departments.length
                                      ) +
                                      " Departman\n                    "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                  ]
                },
              },
              {
                key: "enabled",
                fn: function (text, record) {
                  return [
                    _c("a-switch", {
                      attrs: { checked: record.enabled },
                      on: {
                        change: function (checked) {
                          return _vm.toggleEnabled(record, checked)
                        },
                      },
                    }),
                  ]
                },
              },
              {
                key: "actions",
                fn: function (text, record) {
                  return [
                    _c(
                      "a-space",
                      [
                        _c(
                          "a-tooltip",
                          { attrs: { title: "Klonla" } },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "link", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cloneWebTab(record)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("content_copy"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tooltip",
                          { attrs: { title: "Düzenle" } },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "link", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push(
                                      "/integrations/webtabs/" +
                                        record._id +
                                        "/edit"
                                    )
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("edit"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tooltip",
                          { attrs: { title: "Sil" } },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: {
                                  type: "link",
                                  size: "small",
                                  danger: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDelete(record)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("delete"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }